"use client";
import { useState } from "react";
import { useBlock } from "@/core/blocks/context";
import { AdvancedImageAttr, TextAttr, LinkAttr, IconAttr, RepeaterAttr } from "@/core/blocks/attributes";
import { LangSwitcher } from "@/core/LangSwitcher";

export function Header() {
  const ctx = useBlock();
  const [open, setOpen] = useState(false);
  return (
    <header className="site-header">
      <div className="container header-inner">
        <a className="header-logo" href={ctx.locale === ctx.locales[0] ? "/" : `/${ctx.locale}`}>
          <AdvancedImageAttr fit="contain" position="center center" name="logo" className="header-logo-img" sizes="160px" />
          <TextAttr name="logoText" as="span" className="header-logo-text" placeholder={{ nl: "Sitenaam", en: "Site name" }} />
        </a>
        <button
          type="button"
          className="header-toggle"
          aria-expanded={open}
          aria-controls="header-nav"
          aria-label="Menu"
          onClick={() => setOpen(!open)}
        >
          <span /><span /><span />
        </button>
        <nav id="header-nav" className={`header-nav${open ? " is-open" : ""}`} aria-label={ctx.locale === "nl" ? "Hoofdmenu" : "Main menu"}>
          <RepeaterAttr name="menu" as="ul" className="header-menu" addLabel={{ nl: "Menu-item", en: "Menu item" }} itemDefaults={() => ({})}>
            {() => (
              <li>
                <LinkAttr name="link" onClick={() => setOpen(false)}>
                  <TextAttr name="label" placeholder={{ nl: "Menu-item", en: "Menu item" }} />
                </LinkAttr>
              </li>
            )}
          </RepeaterAttr>
        </nav>
        <div className="header-side">
          <RepeaterAttr name="socials" as="div" className="header-socials" addLabel={{ nl: "Social", en: "Social" }} itemDefaults={() => ({ icon: "social:instagram" })}>
            {() => (
              <LinkAttr name="link" className="header-social">
                <IconAttr name="icon" />
              </LinkAttr>
            )}
          </RepeaterAttr>
          <LangSwitcher className="header-lang" />
          <LinkAttr name="cta" className="btn btn-primary header-cta">
            <TextAttr name="ctaLabel" placeholder={{ nl: "Knoptekst", en: "Call to action" }} />
          </LinkAttr>
        </div>
      </div>
    </header>
  );
}
